import { render, staticRenderFns } from "./SubscriberGroups.vue?vue&type=template&id=1796747e&scoped=true"
import script from "./SubscriberGroups.vue?vue&type=script&lang=js"
export * from "./SubscriberGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1796747e",
  null
  
)

export default component.exports